export default __webpack_public_path__ + "static/media/BC_488_BC_R0118.08c4b09d.jpg";